import Cookies from 'js-cookie'
import { fmUserLogin, fmUserChangeUserPwd, loginInfo, selectUserForResetPassword, sendDigit, resetPasswordToken, getResetPassword} from '@/view/api/ajax'
import { Message } from 'element-ui'
import SideMenuUtils from '@/utils/sideMenuUtils'
import MenuUtils from '@/utils/menuUtils'

/* ----------------------------------------*/
let sideMenus = []
let routers = []
let fmMenus = []
//
function loginData(data) {
  console.log(data,'======= window.sessionStorage.setItem(\'menus\',========');
  window.sessionStorage.setItem('menus', JSON.stringify(data))
  MenuUtils(routers, data)
  window.sessionStorage.setItem('sideMenus', JSON.stringify(sideMenus))
}
//
function filterAsyncRouter(routes) {
  let firstPage = {
    menuId: 1,
    parentId: -1,
    menuNameNick: 'page/index/index',
    menuName: '我的任务',
    menuNameEn: 'My task',
    hasChild: 'N',
    menuDepth: 2,
    childMenus: []
  };
  const sysMenus = []
  // sysMenus.push(firstPage);
  if (routes.menus && routes.menus.childMenus !== null) {
    routes.menus.childMenus.forEach(v => {
      sysMenus.push(v)
    })
  }
  const menu = {
    path: '/',
    menuNameNick: 'layout/Home',
    menuName: 'tms',
    menuNameEn: 'tms',
    hasChild: 'Y',
    isRoot: true
  }
  menu.childMenus = []
  for (let i = 0; i < sysMenus.length; i++) {
    if (sysMenus[i].menuDepth === 2) {
      menu.childMenus.push(sysMenus[i])
    }
  }
  SideMenuUtils(sideMenus, menu.childMenus)
  fmMenus.push(menu)
  loginData(fmMenus)
}
/* ----------------------------------------*/
/**
 * 查找指定级别的第一个菜单，如查找第一个二级菜单，则参数：menus， level=2
 * @param menus
 * @param level
 */
function findFistMenu(menus) {
  if (menus == null) {
    return null;
  }
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].hasChild == 'N') {
      return menus[i];
    } else {
      return findFistMenu(menus[i].childMenus);
    }
  }
}

function dealPath(menuNameNick) {
  while (menuNameNick.indexOf('/') > -1) {
    menuNameNick = menuNameNick.replace('/', '_')
  }
  // menuNameNick = bus.replaceAll('/', '_');
  menuNameNick = '/' + menuNameNick
  return menuNameNick
}
const login = {
  namespaced: true,
  state: {
    addRouters: [],
    clients: [],
    checkedData: null,
    oktaData: null,
    oktaTokenData: null,
    selectResetPasswordObj: null,
    sendDigitObj: null,
    resetPasswordTokenObj: null,
    resetPasswordObj: null,
    slpLogin: null,
    slpSsoLogin: null,
    newSideMenu: null
  },
  mutations: {
    FM_USER_LOGIN_REQUEST(state, data) {
      state.addRouters = routers;
      state.slpLogin = data;
      console.log(data.menus,'==登录===data.menus=====')
      if (!data.menus){
        Message({
          showClose: true,
          message: "当前账号【"+ data.user.userNo + "】未分配角色!",
          type: 'error'
        })
        return;
      }
      if (data.menus.childMenus != null && data.menus.childMenus.length > 0) {
        let firstMenu = findFistMenu(data.menus.childMenus);
        if (firstMenu != null) {
          localStorage.setItem('firstMenuPath', dealPath(firstMenu.menuNameNick));
          localStorage.setItem('firstMenuName', firstMenu.menuName);
        }
      }
      state.clients = data.clients
      sessionStorage.setItem('clients', JSON.stringify(data.clients))
      sessionStorage.setItem('user', JSON.stringify(data.user))
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    FM_USER_CHANGE_USER_PWD_REQUEST: (state, obj) => {
      state.checkedData = obj
    },

    SELECT_USER_FOR_RESET_PASSWORD: (state, data) => {
      state.selectResetPasswordObj = data
    },
    SEND_DIGIT: (state, data) => {
      state.sendDigitObj = data
    },
    RESET_PASSWORD_TOKEN: (state, data) => {
      state.resetPasswordTokenObj = data
    },
    GET_RESET_PASSWORD: (state, data) => {
      state.resetPasswordObj = data
    },
    CHANGE_DIDEMENUS(state, data){
      state.newSideMenu = data;
      window.sessionStorage.setItem('sideMenus', JSON.stringify(data))
    }
  },
  actions: {
    // 登录请求
    async fmUserLoginRequest({ dispatch, commit }, data) {
      let res = await fmUserLogin(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { refreshToken, token } = obj;
        localStorage.setItem("token", token);
        localStorage.setItem("refresh", refreshToken);
        localStorage.setItem('changeUser', 'N');
        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST', obj)
      }
    },
    //切换账号
    async loginInfo({ dispatch, commit }, data) {
      let res = await loginInfo(data)
      if (res.code === 200) {
        const { code, obj } = res;
        const { user } = obj;

        obj.refreshToken = localStorage.getItem("refresh");
        obj.token = localStorage.getItem("token");
        obj.clients = JSON.parse(sessionStorage.getItem('clients'));

        sideMenus = []
        routers = []
        fmMenus = []

        localStorage.clear();
        sessionStorage.clear();

        localStorage.setItem("ms_username", user.userNo);
        localStorage.setItem("token", obj.token);
        localStorage.setItem("refresh", obj.refreshToken);

        filterAsyncRouter(obj)
        commit('FM_USER_LOGIN_REQUEST', obj)
      }
    },

    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    /**
     * 修改密码-提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async fmUserChangeUserPwdRequest({ commit }, obj) {
      const resp = await fmUserChangeUserPwd(obj)
      commit('FM_USER_CHANGE_USER_PWD_REQUEST', resp)
    },

    /**
     * 忘记密码-根据用户获取邮箱信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async selectUserForResetPassword({ commit }, obj) {
      const resp = await selectUserForResetPassword(obj)
      commit('SELECT_USER_FOR_RESET_PASSWORD', resp)
    },

    /**
     * 忘记密码-发送验证码
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async sendDigit({ commit }, obj) {
      const resp = await sendDigit(obj)
      commit('SEND_DIGIT', resp)
    },
    //忘记密码-获取token
    async resetPasswordToken({ commit }, obj) {
      const resp = await resetPasswordToken(obj)
      commit('RESET_PASSWORD_TOKEN', resp)
    },
    //忘记密码-根据邮件重置密码
    async getResetPassword({ commit }, obj) {
      const resp = await getResetPassword(obj)
      commit('GET_RESET_PASSWORD', resp)
    },
    // 切换sideMenu
    async changeSideMenus({ commit }, obj){
      let sMenus = [];
      SideMenuUtils(sMenus, obj)
      commit('CHANGE_DIDEMENUS', sMenus)
    }
  }
}
export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js